export default {
  walletSetting: {
    title: "تنظیمات کیف پول",
    assetsType: "نمایش دارایی‌ها به:",
    nameType: "نمایش نام ارزها به:",
    saveButton: "ذخیره تغییرات",
    cancelButton: "مشاهده",
    assetsTypeList: [
      {
        value: "IRR",
        title: "ریال (IRR)"
      },
      {
        value: "USDT",
        title: "تتر (USDT)"
      }
    ],
    nameTypeList: [
      {
        value: "name_locale",
        title: "فارسی"
      },
      {
        value: "name",
        title: "انگلیسی"
      }
    ]
  },
  walletHero: {
    allAssetsValue: "ارزش کل دارایی‌ها",
    totalProfitLoss: "میزان سود (زیان) کل",
    deposit: "واریز",
    withdrawal: "برداشت",
    exchange: "تبدیل",
    transfer: "انتقال به اسپات",
    otherCurrencies: "ارزهای دیگر",
    showAssets: "نمایش دارایی ها",
    hideAssets: "مخفی کردن دارایی ها"
  },
  walletTable: {
    searchInput: "جستجو براساس نام ارز و یا نام اختصاری...",
    hideZeroAssets: "مخفی کردن دارایی‌های 0",
    returnToInitialSettings: "بازگشت به تنظیمات اولیه",
    tableLayout: "چیدمان جدول",
    tableSetting: "تنظیمات",
    rowPerPage: "تعداد سطر در هر صفحه",
    to: "تا",
    of: "از",
    symbol: "نام ارز",
    name: "نام",
    totalAsset: "دارایی",
    blockedAsset: "دارایی بلوکه شده",
    availableAsset: "دارایی در دسترس",
    currentValue: "ارزش فعلی (IRR)",
    averagePurchasePrice: "میانگین خرید",
    profitLoss: "سود / زیان",
    profitLossRate: "میزان سود / زیان (IRR)",
    assetPercentageFromTotal: "درصد دارایی از کل",
    operation: "عملیات",
    update: "بروزرسانی"
  },
  checkMarketTerms: {
    traderTermsDesc:
      "کاربر گرامی، برای کار با بخش اکسکوینو مارکت باید ابتدا قوانین این بخش را بپذیرید. برای اینکار ابتدا به بخش اکسکوینو مارکت رفته و بعد از مطالعه قوانین و پیذیرفتن آن، مجدد برای انتقال رمز ارز به این صفحه باز گردید.",
    goToTrader: "رفتن به اکسکوینو مارکت"
  },
  operationsInTable: {
    deposit: "واریز",
    withdraw: "برداشت",
    exchange: "تبدیل",
    transfer: "انتقال به اسپات"
  },
  noRowsTemplate: {
    noCurrenciesFound: "هیچ ارزی یافت نشد"
  },
  notLoading: {
    loading: "در حال بارگذاری"
  }
};
